import React, { useMemo } from 'react';
import Streamline from '@/components/shared/streamline/Streamline';
import { isEmpty } from '@/shared/utility';
import Large from '@/components/shared/streamline/children-layouts/Large';
import GameProviderCard from '@/components/shared/card/GameProviderCard';

const GameProvidersLargeStreamline = ({
  slug,
  gameProviders,
  onClick,
}: {
  slug: string;
  gameProviders: string[];
  onClick: (providerSlug: string) => void;
}) => {
  const children = useMemo(() => {
    if (isEmpty(gameProviders)) return <div />;
    return gameProviders.map(provider => (
      <Large key={`${slug}-${provider}`}>
        <GameProviderCard slug={provider} onClick={() => onClick(provider)} />
      </Large>
    ));
  }, [gameProviders]);

  return <Streamline loop children={children} />;
};

export default GameProvidersLargeStreamline;
